import React from 'react';

class RuntimeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('VinCentrix render crash:', error, info);
    this.setState({ info });
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        background: '#000000',
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '900px',
          background: 'linear-gradient(145deg, rgba(255,255,255,.10), rgba(255,255,255,.03))',
          border: '1px solid rgba(255,255,255,.12)',
          borderRadius: '20px',
          padding: '28px',
          boxShadow: '0 20px 60px rgba(0,0,0,.5)'
        }}>
          <div style={{ fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase', color: '#60a5fa', marginBottom: '12px' }}>
            VinCentrix Runtime Error
          </div>
          <h1 style={{ margin: '0 0 16px', fontSize: '28px' }}>Dashboard render failed</h1>
          <div style={{
            background: 'rgba(239,68,68,.08)',
            border: '1px solid rgba(239,68,68,.25)',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '16px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}>
            {String(error?.message || error)}
          </div>
          {info?.componentStack && (
            <details open>
              <summary style={{ cursor: 'pointer', marginBottom: '10px', color: 'rgba(255,255,255,.72)' }}>Component stack</summary>
              <pre style={{
                margin: 0,
                padding: '16px',
                overflow: 'auto',
                background: 'rgba(255,255,255,.04)',
                borderRadius: '12px',
                color: 'rgba(255,255,255,.78)',
                fontSize: '12px',
                whiteSpace: 'pre-wrap'
              }}>{info.componentStack}</pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}

export default RuntimeErrorBoundary;
